var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "System Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0.5)",
    fill: "#1BA31B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5166 3.21542C12.4096 2.78771 14.3902 2.9834 16.163 3.77329C16.6675 3.99807 17.2587 3.77134 17.4834 3.26687C17.7082 2.76239 17.4815 2.17122 16.977 1.94644C14.8103 0.981007 12.3896 0.741837 10.0758 1.2646C7.76206 1.78736 5.67929 3.04404 4.13811 4.84722C2.59693 6.6504 1.67992 8.90346 1.52384 11.2704C1.36777 13.6373 1.98099 15.9913 3.27206 17.9812C4.56312 19.9711 6.46285 21.4904 8.68792 22.3125C10.913 23.1345 13.3442 23.2153 15.6189 22.5427C17.8936 21.8702 19.89 20.4803 21.3103 18.5804C22.7306 16.6806 23.4986 14.3719 23.5 11.9999V11.0799C23.5 10.5276 23.0523 10.0799 22.5 10.0799C21.9477 10.0799 21.5 10.5276 21.5 11.0799V11.9993C21.4989 13.9401 20.8705 15.8285 19.7084 17.3829C18.5464 18.9374 16.913 20.0745 15.0518 20.6248C13.1907 21.1751 11.2015 21.109 9.38102 20.4364C7.56051 19.7638 6.00619 18.5208 4.94987 16.8927C3.89354 15.2645 3.39181 13.3386 3.51951 11.402C3.64721 9.4654 4.39749 7.62199 5.65845 6.14666C6.91942 4.67133 8.62351 3.64314 10.5166 3.21542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2075 4.70651C23.5978 4.31579 23.5975 3.68262 23.2068 3.2923C22.816 2.90197 22.1829 2.90228 21.7925 3.293L12.4996 12.5952L10.2071 10.3026C9.81658 9.91212 9.18342 9.91212 8.79289 10.3026C8.40237 10.6932 8.40237 11.3263 8.79289 11.7169L11.7929 14.7169C11.9805 14.9045 12.2349 15.0098 12.5002 15.0098C12.7656 15.0097 13.02 14.9042 13.2075 14.7165L23.2075 4.70651Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.b2683b4ba89ee54863d70b960f657a69.svg";
export { ForwardRef as ReactComponent };